import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lyceoRemoveWhitespace',
})
export class RemoveWhitespacePipe implements PipeTransform {
  public transform(value: string | undefined | null): string | null {
    if (typeof value === 'string') {
      const regexp: RegExp =
        /<p(\sstyle="[a-z-:;\d]+")?>(<i>)?(<strong>)?(&nbsp;)?(<\/strong>)?(<\/i>)?<\/p>/g;
      return value.replace(regexp, '');
    }

    return '';
  }
}
